const preprocessorSend = (values) => ({
  _id: values._id,
  usage_id: values.usage_id,
  usage_type_id: values.usage_type_id,
  status_id: values.status_id,
  sale_price: values.sale_price,
  rent_price: values.rent_price,
  for_sale: values.sale_price > 0,
  for_rent: values.rent_price > 0,
  location_street_address: values.location_street_address,
  location_street_number: values.location_street_number,
  location_add_on_address: values.location_add_on_address,
  location_city: values.location_city,
  location_neighborhood: values.location_neighborhood,
  location_zipcode: values.location_zipcode.replace(/[^0-9]/g, ''),
  tx_quadra: values.tx_quadra || null,
  id_cartorio: values.id_cartorio ? parseInt(values.id_cartorio, 10) : null,
  dl_comissao: values.dl_comissao ? parseFloat(values.dl_comissao) : null,
});

export default preprocessorSend;
